export default __webpack_public_path__ + "static/media/BG-Cell.d38b6475.png";